/**
 * システム管理API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 金融機関マスタ検索情報
 */
export interface Szza020aRequestBankMasterSrchInfDto { 
    /**
     * 外部金融機関コード：数字
     */
    extBankfcCode?: string | null;
    /**
     * 外部支店コード：数字
     */
    extBranchCode?: string | null;
    /**
     * 適用開始日付（From）：日付(yyyyMMdd)
     */
    applyStartDateFrom?: string | null;
    /**
     * 適用開始日付（To）：日付(yyyyMMdd)
     */
    applyStartDateTo?: string | null;
    /**
     * 金融機関漢字名：全角
     */
    bankfcAname?: string | null;
    /**
     * 金融機関カナ名：全角（カナ）
     */
    bankfcKanaAname?: string | null;
    /**
     * 金融機関支店漢字名：全角
     */
    branchAname?: string | null;
    /**
     * 金融機関支店カナ名：全角（カナ）
     */
    branchKanaAname?: string | null;
    /**
     * 金融機関支店廃止日付（From）：日付(yyyyMMdd)
     */
    bankfcHaisiDateFrom?: string | null;
    /**
     * 金融機関支店廃止日付（To）：日付(yyyyMMdd)
     */
    bankfcHaisiDateTo?: string | null;
}

